import React from 'react';

const CheckboxField = (props) => {
  return (
    <input type="checkbox" {...props}/>
  );
};

export default CheckboxField;
